import { createContext, useCallback, useContext, useState } from "react";

const Ctx = createContext(null);

export function CerteroProvider({ children }) {
  const [lead, setLead] = useState({ open: false, tipo: "cotizacion", interes: null });
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [calServicio, setCalServicio] = useState(null);

  const openLead = useCallback(
    (tipo = "cotizacion", interes = null) => setLead({ open: true, tipo, interes }),
    []
  );
  const closeLead = useCallback(() => setLead((s) => ({ ...s, open: false })), []);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <Ctx.Provider value={{ lead, openLead, closeLead, privacyOpen, setPrivacyOpen, scrollToId, calServicio, setCalServicio }}>
      {children}
    </Ctx.Provider>
  );
}

export const useCertero = () => useContext(Ctx);
